module.exports = __webpack_public_path__ + "media/images/ecalls/bitcoin_dinner-21675e695a3eb259b821eee169a207b0.png";